export const GET_ORDER_BOOK = "GET_ORDER_BOOK";
export const GET_MF_ORDER_BOOK = "GET_MF_ORDER_BOOK";
export const GET_NFO_ORDER_BOOK = "GET_NFO_ORDER_BOOK";
export const GET_IPO_ORDER_BOOK = "GET_IPO_ORDER_BOOK";
export const GET_MFH_ORDER_BOOK = "GET_MFH_ORDER_BOOK";
export const GET_EQSIP_ORDER_BOOK = "GET_EQSIP_ORDER_BOOK";
export const GET_MFSIP_ORDER_BOOK = "GET_MFSIP_ORDER_BOOK";
